export default __webpack_public_path__ + "static/divanru-830b5a13321bb29466f622b23bd169f6.png";